import React, { useEffect, useRef, useState } from 'react';
import PageTransition from './PageTransition.jsx'; 
import { useScrollSmoother } from '../context/ScrollSmootherContext.jsx';

const SiteLoader = ({ inSuspance = false }) => {
	const [isLogoComplete, setLogoComplete] = useState(false);
	const [isComplete, setIsComplete] = useState(false);
	const loaderRef = useRef(null);
	const logoUp = useRef(null);
	const logoDown = useRef(null);
	const logosDuration = 1;
	const smoother = useScrollSmoother();

	useEffect(() => {
		gsap.to(window, { duration: 1, scrollTo: 0 });

		const animationConfig = {
			duration: logosDuration,
			delay: logosDuration,
			ease: 'power1.out',
			repeat: inSuspance ? -1 : 0,
			yoyo: true,
		};

		gsap.fromTo(
			logoUp.current,
			{ x: 0 },
			{
				x: '-8px',
				...animationConfig,
			}
		);

		gsap.fromTo(
			logoDown.current,
			{ x: 0 },
			{
				x: '8px',
				...animationConfig,
				onComplete: () => {
					if (!inSuspance) {
						setLogoComplete(true);
					}
				},
			}
		);

		return () => {
			gsap.killTweensOf([logoUp.current, logoDown.current, loaderRef.current]);
		};
	}, [inSuspance]);

	useEffect(() => {
		if (isLogoComplete && !inSuspance) {
			gsap.to(loaderRef.current, {
				scale: 5,
				opacity: 0,
				filter: 'blur(30px)',
				duration: logosDuration,
				ease: 'power1.out',
				onComplete: () => {
					loaderRef.current.remove();
					setIsComplete(true);
				},
			});
		}
	}, [isLogoComplete, inSuspance]);

	useEffect(() => {
		if (inSuspance) {
			// Disable scroll
			document.body.style.overflow = 'hidden';
			if (smoother.current) {
				smoother.current.paused(true);
			}
		} else {
			// Enable scroll
			document.body.style.overflow = '';
			if (smoother.current) {
				smoother.current.paused(false);
			}
		}

		return () => {
			document.body.style.overflow = '';
			if (smoother.current) {
				smoother.current.paused(false);
			}
		};
	}, [inSuspance, smoother]);

	return (
		<>
			<div
				className={`${inSuspance ? 'suspance-loader vh-100' : 'h-100'} site-loader-half w-100 position-fixed top-0`}
				ref={loaderRef}
			>
				<div className="d-flex flex-column justify-content-center align-items-center">
					<img
						src="/Content/img/logo-epoca-half.png"
						alt="logo"
						className="logo-up"
						ref={logoUp}
					/>
					<img
						src="/Content/img/logo-epoca-half.png"
						alt="logo"
						className="logo-down"
						ref={logoDown}
					/>
				</div>
			</div>
			{!inSuspance && <PageTransition running={isComplete} />}
		</>
	);
};

export default SiteLoader;
